import React from 'react'
import PropTypes from 'prop-types'
import CalendarMonth from '@mui/icons-material/CalendarMonth'

const CalendarMonthIcon = ({ height, width, ...more }) => {
	
	return (
		<CalendarMonth
			height={height}
			width={width}
			{...more}
		/>
	)
}

CalendarMonthIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default CalendarMonthIcon
